<main class="main-content --{{ sideRedering }} {{ actualPath }}">
  <router-outlet>
    <app-header></app-header>
  </router-outlet>
</main>

<app-footer></app-footer>
